export default [
  {
    "name": "Adonis"
  },
  {
    "name": "AgilityJS"
  },
  {
    "name": "Ampersand"
  },
  {
    "name": "Angular2"
  },
  {
    "name": "AngularJS"
  },
  {
    "name": "Angular-Meteor"
  },
  {
    "name": "animeJS"
  },
  {
    "name": "Appium"
  },
  {
    "name": "Async"
  },
  {
    "name": "Aurelia"
  },
  {
    "name": "Babel"
  },
  {
    "name": "Backbone"
  },
  {
    "name": "Blaze_CSS"
  },
  {
    "name": "Bluebird"
  },
  {
    "name": "Bootstrap"
  },
  {
    "name": "Bosonic"
  },
  {
    "name": "Bower"
  },
  {
    "name": "Brocolli"
  },
  {
    "name": "Browserify"
  },
  {
    "name": "CanJS"
  },
  {
    "name": "Cappuccino"
  },
  {
    "name": "Chai"
  },
  {
    "name": "Chaplin"
  },
  {
    "name": "ChartJS"
  },
  {
    "name": "CoffeeScript"
  },
  {
    "name": "CommonJS"
  },
  {
    "name": "Cordova"
  },
  {
    "name": "CycleJS"
  },
  {
    "name": "D3"
  },
  {
    "name": "Deku"
  },
  {
    "name": "Delorean"
  },
  {
    "name": "Dojo"
  },
  {
    "name": "Durandal"
  },
  {
    "name": "EchoJS"
  },
  {
    "name": "Electron"
  },
  {
    "name": "Ember"
  },
  {
    "name": "Enyo"
  },
  {
    "name": "ES6"
  },
  {
    "name": "ESLint"
  },
  {
    "name": "ExpressJS"
  },
  {
    "name": "Firebase"
  },
  {
    "name": "Flight"
  },
  {
    "name": "Flux"
  },
  {
    "name": "Foundation"
  },
  {
    "name": "Globalize"
  },
  {
    "name": "GnosisJS"
  },
  {
    "name": "Grunt"
  },
  {
    "name": "Gulp"
  },
  {
    "name": "Gwt"
  },
  {
    "name": "Handlebars"
  },
  {
    "name": "Highcharts"
  },
  {
    "name": "Holmes"
  },
  {
    "name": "HowlerJS"
  },
  {
    "name": "Immutable"
  },
  {
    "name": "Inferno"
  },
  {
    "name": "InterledgerJS"
  },
  {
    "name": "Intern"
  },
  {
    "name": "Ionic"
  },
  {
    "name": "Jasmine"
  },
  {
    "name": "JerryScript"
  },
  {
    "name": "Jest"
  },
  {
    "name": "jQuery"
  },
  {
    "name": "jQueryMobile"
  },
  {
    "name": "jQueryUI"
  },
  {
    "name": "JSBlocks"
  },
  {
    "name": "Jspm"
  },
  {
    "name": "JSweet"
  },
  {
    "name": "JSX"
  },
  {
    "name": "Jumpsuit"
  },
  {
    "name": "Karma"
  },
  {
    "name": "KendoUI"
  },
  {
    "name": "KeyStone"
  },
  {
    "name": "Knockout"
  },
  {
    "name": "KrakenJS"
  },
  {
    "name": "Leaflet"
  },
  {
    "name": "Less"
  },
  {
    "name": "Lodash"
  },
  {
    "name": "MarionetteJS"
  },
  {
    "name": "Materialize"
  },
  {
    "name": "Matreshka"
  },
  {
    "name": "Meteor"
  },
  {
    "name": "Mithril"
  },
  {
    "name": "Mobx"
  },
  {
    "name": "Mocha"
  },
  {
    "name": "Modernizr"
  },
  {
    "name": "MomentJS"
  },
  {
    "name": "NativeScript"
  },
  {
    "name": "NativeScript-Angular"
  },
  {
    "name": "Nodal"
  },
  {
    "name": "NodeJS"
  },
  {
    "name": "Node-RED"
  },
  {
    "name": "npm"
  },
  {
    "name": "OfflineJS"
  },
  {
    "name": "PhantomJS"
  },
  {
    "name": "Phaser"
  },
  {
    "name": "PixiJS"
  },
  {
    "name": "PEP"
  },
  {
    "name": "Polymer"
  },
  {
    "name": "PostCSS"
  },
  {
    "name": "Preact"
  },
  {
    "name": "PrimeNG"
  },
  {
    "name": "Prototype"
  },
  {
    "name": "PureScript"
  },
  {
    "name": "PyJS"
  },
  {
    "name": "Qunit"
  },
  {
    "name": "RactiveJS"
  },
  {
    "name": "Ramda"
  },
  {
    "name": "React"
  },
  {
    "name": "Redux"
  },
  {
    "name": "RequireJS"
  },
  {
    "name": "RevealJS"
  },
  {
    "name": "Riot"
  },
  {
    "name": "RxJS"
  },
  {
    "name": "Sails"
  },
  {
    "name": "SammyJS"
  },
  {
    "name": "Seneca"
  },
  {
    "name": "Sizzle"
  },
  {
    "name": "SkateJS"
  },
  {
    "name": "SkelJS"
  },
  {
    "name": "Slick"
  },
  {
    "name": "SocketIO"
  },
  {
    "name": "Sproutcore"
  },
  {
    "name": "Stapesjs"
  },
  {
    "name": "Stylus"
  },
  {
    "name": "SystemJS"
  },
  {
    "name": "ThreeJS"
  },
  {
    "name": "Trails"
  },
  {
    "name": "TurnJS"
  },
  {
    "name": "TypeScript"
  },
  {
    "name": "UnderscoreJS"
  },
  {
    "name": "UnitJS"
  },
  {
    "name": "Vaadin"
  },
  {
    "name": "Vue"
  },
  {
    "name": "Wakanda"
  },
  {
    "name": "Webix"
  },
  {
    "name": "Webpack"
  },
  {
    "name": "winJS"
  },
  {
    "name": "X-tag"
  },
  {
    "name": "Yarn"
  },
  {
    "name": "Yeoman"
  },
  {
    "name": "Yui"
  },
  {
    "name": "ZeptoJS"
  }
]
